export enum SearchType {
  EXACT_MATCH = 'exact_match',
  STARTS_WITH = 'starts_with',
  INCLUDES = 'includes',
}
